module.exports = __webpack_public_path__ + "static/mighty_fortress-b47c70b61c0abafbe855d975e22f1a18.jpg";